import React from 'react';
export function Footer() {
  return <footer className="border-t border-gold/20 bg-ink px-4 py-8 text-center" data-id="element-123" data-mp="32wd2cf6gdjt0">
      <p className="text-sm text-cream/60" data-id="element-124" data-mp="3ggaovpzpm32t">
        © 2026 Salsa & Bachata Instructor Ready — All rights reserved.
      </p>
    </footer>;
}